import React from 'react';
import { Icon } from './Icon.js';
export const IconRectLayoutGrid2Fill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("rect", { x: "1.5", y: "7", width: "8", height: "4", fill: "currentColor" }),
        React.createElement("path", { d: "M9.5,5.5V2H4.25c-1.517,0-2.75,1.233-2.75,2.75v.75H9.5Z", fill: "currentColor" }),
        React.createElement("path", { d: "M9.5,12.5H1.5v.75c0,1.517,1.233,2.75,2.75,2.75h5.25v-3.5Z", fill: "currentColor" }),
        React.createElement("path", { d: "M13.75,2h-2.75v14h2.75c1.517,0,2.75-1.233,2.75-2.75V4.75c0-1.517-1.233-2.75-2.75-2.75Z", fill: "currentColor", "data-color": "color-2" })));
};
//# sourceMappingURL=IconRectLayoutGrid2Fill18.js.map